import React from 'react'
import { Link } from 'react-router-dom'

import './InnerHeader.scss'

function InnerHeader(props) {
    return (
        <div className='InnerHeader_main'>
            <div className="container">
                <div className="page_link_otr">
                    <Link to="/" className="link_inner heading_h3">Home</Link>
                    <svg className="icon" width="10" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2l6 6-6 6" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>
                    <p className="link_inner heading_h3">{props.Heading}</p>
                </div>
            </div>
        </div>
    )
}

export default InnerHeader